import axios from 'axios';
import CryptoJS from 'crypto-js';

const axiosServices = axios.create({ baseURL: '/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

const decryptData = (encryptedData) => {
  if (!encryptedData) {
    console.error('Encrypted data is undefined');
    return null;
  }
  try {
    const secretKey = process.env.REACT_APP_DATA_DECRYPT_KEY;
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { mode: CryptoJS.mode.ECB });
    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Error decrypting data:', error);
    return null;
  }
};

axiosServices.interceptors.response.use(
  (response) => {
    if (response.data) {
      // Decrypt the encrypted data in the response
      const decryptedData = decryptData(response.data);
      response.data = decryptedData; // Assuming the decrypted data is JSON
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      window.location = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
